import colors from '@settings/styleSettings'

export const getMeterValue = (value, maxValue) => {
  return (value / maxValue) * 100 < 1 && (value / maxValue) * 100 !== 0
    ? ((value / maxValue) * 100).toFixed(1)
    : ((value / maxValue) * 100).toFixed(0)
}

export const getMeterColor = (percentage) => {
  if (percentage <= 33) return colors.strongGreen
  if (percentage <= 66) return colors.strongYellow
  return colors.strongRed
}
